import { otto } from "@gr-exports/async/nexus";
import {
  runWithMicrotask,
  runWithMacrotask,
  runWithAnimationFrame,
  runWithRenderSlice,
} from "./async/promise";

otto.grcore.assignNamespace(
  {
    runWithMicrotask,
    runWithMacrotask,
    runWithAnimationFrame,
    runWithRenderSlice,
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);
